import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail } from 'lucide-react';
import { Button } from '@/components/shared/ui/button';
import { useAppConfig } from '@/contexts/AppConfigContext';

export const Footer = () => {
  const { config } = useAppConfig();
  
  // SEO and General Config
  const seoConfig = config?.seo;
  const businessConfig = config?.business;
  
  const siteName = seoConfig?.siteName || businessConfig?.name || 'Match Active';
  const description = seoConfig?.defaultDescription || 'Match Active: Ropa deportiva exclusiva con envíos seguros a todo México. Calidad premium y diseños únicos.';
  
  // Social Media
  const socialMedia = seoConfig?.socialMedia || {};
  
  // Contact Info
  const contact = businessConfig?.contact;
  const address = businessConfig?.address;
  const fullAddress = (address?.street && address?.city) 
    ? `${address.street}, ${address.city}, ${address.country}` 
    : 'Ciudad de México, México';
  const phone = contact?.phone || '+52 55 1234 5678';
  const email = contact?.email || 'ventas@matchactive.shop';
  
  return (
    <footer className="bg-muted/30 border-t font-montserrat" style={{ background: '#000000' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-7">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
          {/* Logo y descripción */}
          <div className="space-y-2">
            <img
              src="/images/LOGOMATCH_opt.webp"
              alt={`${siteName} Logo`}
              className="h-8 w-auto object-contain"
              loading="lazy"
            />
            <p className="text-xs text-gray-300 font-montserrat">
              {description}
            </p>
            <div className="flex space-x-2 text-center">
              {socialMedia.facebook && (
                <a href={socialMedia.facebook} target="_blank" rel="noopener noreferrer">
                  <Button variant="ghost" size="icon" className="h-8 w-8 text-white hover:text-gray-300" aria-label="Visitar Facebook">
                    <Facebook className="h-4 w-4" />
                  </Button>
                </a>
              )}
              {socialMedia.instagram && (
                <a href={socialMedia.instagram} target="_blank" rel="noopener noreferrer">
                  <Button variant="ghost" size="icon" className="h-8 w-8 text-white hover:text-gray-300" aria-label="Visitar Instagram">
                    <Instagram className="h-4 w-4" />
                  </Button>
                </a>
              )}
              {socialMedia.twitter && (
                <a href={socialMedia.twitter} target="_blank" rel="noopener noreferrer">
                  <Button variant="ghost" size="icon" className="h-8 w-8 text-white hover:text-gray-300" aria-label="Visitar Twitter">
                    <Twitter className="h-4 w-4" />
                  </Button>
                </a>
              )}
            </div>
          </div>
          {/* Enlaces rápidos */}
          <div className="space-y-2">
            <h3 className="font-semibold text-white font-montserrat">Enlaces Rápidos</h3>
            <ul className="space-y-2 text-xs font-montserrat">
              <li>
                <Link to="/tienda" className="text-gray-300 hover:text-white transition-colors font-montserrat">
                  Tienda
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-gray-300 hover:text-white transition-colors font-montserrat">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/perfil?tab=favorites" className="text-gray-300 hover:text-white transition-colors font-montserrat">
                  Favoritos
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div className="space-y-4">
            <h3 className="font-semibold text-white font-montserrat">Contacto</h3>
            <div className="space-y-3 text-xs font-montserrat">
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-gray-300" />
                <span className="text-gray-300 font-montserrat">
                  {fullAddress}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-gray-300" />
                <span className="text-gray-300 font-montserrat">
                  {phone}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-gray-300" />
                <span className="text-gray-300 font-montserrat">
                  {email}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t mt-4 pt-4 text-center text-xs text-gray-300 font-montserrat">
          <p className='font-montserrat'>&copy; {new Date().getFullYear()} {siteName}. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};